import { createSlice } from "@reduxjs/toolkit";

const initialAttendanceState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  authorities: null,
  sections: [],
  dailyCourseHour: 0,
  studentAbsenteeisms: []
};

export const callTypes = {
  list: "list",
  action: "action"
};

export const attendanceSlice = createSlice({
  name: "attendance",
  initialState: initialAttendanceState,
  reducers: {
    startCall: (state, action) => {
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    // getTeachersAndDailyCourseHour
    teachersAndDailyCourseHourFetched: (state, action) => {
      const { isSuccess, type, entity } = action.payload;
      state.actionsLoading = false;
      state.isSuccess = isSuccess;
      state.type = type;
      state.teachers = entity && entity.teachers;
      state.dailyCourseHour = entity && entity.dailyCourseHour;
    },
    // getSectionAttendances
    sectionsAttendancesFetched: (state, action) => {
      const { isSuccess, type, totalCount, authorities, entities } = action.payload;
      state.listLoading = false;
      state.isSuccess = isSuccess;
      state.type = type;      
      state.totalCount = totalCount;
      state.authorities = authorities;
      state.entities = [];

      entities && entities.forEach(entity => {
        const newEntity = {
          id: entity.id,
          section: entity.section
        };
        for (let i = 0; i < state.dailyCourseHour; i++) newEntity["courseHour" + (i + 1)] = entity.attendanceStatuses[i];
        state.entities.push(newEntity);
      });
    },
    // getAttendanceDetails
    attendanceDetailsFetched: (state, action) => {
      const { isSuccess, type, entity } = action.payload;
      state.actionsLoading = false;
      state.isSuccess = isSuccess;
      state.type = type;

      if (entity) {
        state.section = entity.section;
        state.teacher = entity.teacher;
        state.attendanceTime = entity.attendanceTime;
        state.courseStartHour = entity.courseStartHour;
      }      
    },
    // getStudents
    studentsFetched: (state, action) => {
      const { isSuccess, type, totalCount, entities, authorities } = action.payload;
      state.listLoading = false;
      state.isSuccess = isSuccess;
      state.type = type;
      state.entities = entities;
      state.totalCount = totalCount;
      state.authorities = authorities;
    },
    // getSections
    sectionsFetched: (state, action) => {
      const { isSuccess, type, entity } = action.payload;
      state.actionsLoading = false;
      state.isSuccess = isSuccess;
      state.type = type;
      state.sections = entity && entity.sections;
      state.dailyCourseHour = entity && entity.dailyCourseHour;
    },
    // getStudentAbsenteeisms
    studentAbsenteeismsFetched: (state, action) => {
      const { isSuccess, type, totalCount, authorities, entities } = action.payload;
      state.listLoading = false;
      state.isSuccess = isSuccess;
      state.type = type;      
      state.totalCount = totalCount;
      state.authorities = authorities;
      state.studentAbsenteeisms = [];
      state.entities = [];

      entities.forEach(entity => {
        const newEntity = {
          id: entity.id,
          parentId: entity.parentId,
          studentNumber: entity.studentNumber,
          studentName: entity.studentName
        };
        for (let i = 0; i < state.dailyCourseHour; i++) newEntity["courseHour" + (i + 1)] = entity.attendanceStatuses[i];
        state.entities.push(newEntity);        
        state.studentAbsenteeisms.push({
          id: entity.id,
          parentId: entity.parentId,
          studentName: entity.studentName,
          absenteeismStatus: entity.absenteeismStatus,
          explanation: entity.explanation
        });
      });
    },
    // completeAction
    actionCompleted: (state) => {
      state.actionsLoading = false;
    },
    // cleanAttendanceState
    attendanceStateCleaned: (state) => {
      state.listLoading = false;
      state.actionsLoading = false;
      state.isSuccess = undefined;
      state.type = undefined;
      state.authorities = null;
      state.entities = undefined;
      state.totalCount = 0;
    }
  }
});